import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rx-list',
  templateUrl: './rx-list.component.html',
  styleUrls: ['./rx-list.component.scss'],
})
export class RxListComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
